import { GroupedDiffusionResponse } from '../../lib/types/models/affectedStaff/affected-staff'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export const diffuseTravelChoices = async (id: number) => {
  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.diffuseTravelChoices.url, { id }))
    .post()
}

export const diffuseHostFamilyAccommodation = async (id: number) => {
  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.diffuseHostFamilyAccommodation.url, { id }))
    .post<GroupedDiffusionResponse>()
}

export const diffuseTeam = async (id: number) => {
  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.diffuseTeam.url, { id }))
    .post<GroupedDiffusionResponse>()
}

export const diffuseTeams = async (ids: number[]) => {
  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.diffuseTeams.url, null))
    .post<GroupedDiffusionResponse>({ ids })
}

export const diffuseHostFamilyAccommodations = async (ids: number[]) => {
  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.diffuseHostFamilyAccommodations.url, null))
    .post<GroupedDiffusionResponse>({ ids })
}

export const diffuseOlInfos = async (ids: number[]) => {
  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.diffuseOlInfos.url, null))
    .post<GroupedDiffusionResponse>({ ids })
}

export const diffuseTravelInformation = async (id: number) => {
  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.diffuseTravelInformation.url, { id }))
    .post<GroupedDiffusionResponse>()
}

export const diffuseTravelInformations = async (ids: number[]) => {
  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.diffuseTravelInformations.url, null))
    .post<GroupedDiffusionResponse>({ ids })
}

export const diffuseCourseLocation = async (id: number) => {
  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.diffuseCourseLocation.url, { id }))
    .post()
}
